var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"osm-address"},[_c('p',{staticClass:"osm-address-text"},[_vm._l((_vm.addressLines),function(line){return [_c('span',{key:line,staticClass:"osm-address-line",attrs:{"title":line}},[_vm._v(_vm._s(line))]),_vm._v(" "),_c('br',{key:line})]})],2),_vm._v(" "),_c('div',{staticClass:"loading",class:{ visible: _vm.loading }})])
}
var staticRenderFns = []

export { render, staticRenderFns }